module.exports = __webpack_public_path__ + "img/pruvo_classroom_icon.f7866b05.png";